const backendUrl = process.env.REACT_APP_BACKEND_URL ?? "";
export const BASE_URL = backendUrl.replace(/\/+$/, "");
export const API_BASE_URL = `${BASE_URL}/api`;
export const IS_DEVELOPMENT = process.env.NODE_ENV !== "production";
